import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "sidebar-menu-item-content" };
const _hoisted_2 = { class: "sidebar-icon" };
const _hoisted_3 = { class: "sidebar-item-label" };
import { computed } from 'vue';
import ArrowDownIcon from '../assets/icons/arrow-down.svg';
import { getMenuItemIconName } from '../utils/nav';
import NamedIcon from './named-icon.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'sidebar-menu-item',
    props: {
        isExpanded: { type: Boolean },
        menuItem: {}
    },
    setup(__props) {
        const props = __props;
        const isParentItem = computed(() => Array.isArray(props.menuItem.items) && props.menuItem.items.length > 0);
        const iconName = computed(() => getMenuItemIconName(props.menuItem));
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_resolveDynamicComponent(isParentItem.value ? 'button' : 'a'), {
                class: _normalizeClass(["sidebar-menu-item", { 'is-selected': __props.menuItem.isSelected }]),
                href: isParentItem.value ? undefined : __props.menuItem.url,
                "data-link-name": isParentItem.value ? undefined : __props.menuItem.analytics,
                "aria-expanded": isParentItem.value ? __props.isExpanded : undefined
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            (iconName.value)
                                ? (_openBlock(), _createBlock(NamedIcon, {
                                    key: 0,
                                    name: iconName.value
                                }, null, 8, ["name"]))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("span", _hoisted_3, _toDisplayString(__props.menuItem.label), 1),
                        (isParentItem.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["sidebar-arrow-icon", { 'up': __props.isExpanded }])
                            }, [
                                _createVNode(NamedIcon, {
                                    name: _unref(ArrowDownIcon).id
                                }, null, 8, ["name"])
                            ], 2))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _: 1
            }, 8, ["class", "href", "data-link-name", "aria-expanded"]));
        };
    }
});
